import { connect } from 'react-redux'
import StopDescription from '../components/stopdescription/StopDescription'
import { currentStop, pointInfo, mediaListByType, selectedLanguage } from 'aria-viewer/utils/functions'
import { forceMediaPause } from 'aria-viewer/interactive-element/actions/common'
import { hideDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { MEDIA_MODULE_TYPES } from 'aria-viewer/tour/constants'
import { setStopDescriptionOpen, setSupplementalMediaType } from '../actions/stopDescriptionActions'

const getSupplementalMediaFromMediaList = mediaListByType => [
    ...mediaListByType[MEDIA_MODULE_TYPES.PANOS],
    ...mediaListByType[MEDIA_MODULE_TYPES.PHOTOS],
    ...mediaListByType[MEDIA_MODULE_TYPES.VIDEOS],
]

const mapStateToProps = state => ({
    title: currentStop(state).title,
    description: pointInfo(state).description,
    supplementalMedia: getSupplementalMediaFromMediaList(mediaListByType(state)),
    language: selectedLanguage(state).get('language'),
    containerSize: {
        width: state.getIn(['device', 'viewportWidth']),
        height: state.getIn(['device', 'viewportHeight']),
    },
})

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(forceMediaPause(false))
        dispatch(hideDrawer())
        dispatch(setStopDescriptionOpen(false))
        dispatch(setSupplementalMediaType(null))
    },

    onMediaClick: media => {
        dispatch(setSupplementalMediaType(media.mediaType))
    },

    onModalClose: _ => {
        dispatch(setSupplementalMediaType(null))
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StopDescription)
